import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getHighRiskSupplementsList } from '@api/highRiskSupplements';
import {
  IHighRiskSupplementSearchDTO,
  IRiskSupplementsTableData,
} from '@interfaces/highRiskSupplements';

import { buildHighRiskSupplementsSearchPayload } from './utils';

export const handleSearchHighRiskSupplements = createAsyncThunk<
  AxiosResponse<IRiskSupplementsTableData>,
  IHighRiskSupplementSearchDTO
>('searchHighRiskSupplements', props =>
  getHighRiskSupplementsList(buildHighRiskSupplementsSearchPayload(props)),
);
